import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const HittaElomrade = lazy(() => import("@/pages/verktyg/HittaElomrade"));

export const Route = createFileRoute("/verktyg/hitta-elomrade")({
  head: () => seoHead("/verktyg/hitta-elomrade", { description: "Sök på ditt postnummer så ser du om du tillhör SE1, SE2, SE3 eller SE4." }),
  component: () => <HittaElomrade />,
});
